import { useCallback, useEffect, useState } from "react";
import { Breadcrumb, Card, Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Link, useParams } from "react-router-dom";
import { BdaModelDTO } from "../../models/BdaModel";
import AppLoader from "../../components/common/AppLoader";
import { Alert } from "antd";
import AssetEditForm from "../../components/forms/AssetEditForm";
import { useToasts } from "../../contexts/toasts";
import { Models } from "../../api/Models";

export default function ModelEdit() {
  const { id } = useParams();
  const { showToast } = useToasts();
  const [model, setModel] = useState<BdaModelDTO>();
  const [error, setError] = useState(false);

  const retrieveModel = useCallback(() => {
    Models.getModel(+id!)
      .then(
        ({ data }) => setModel(data),
        (err) => {
          setError(true);
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('models-error', message, `Models Error ${status ? `(${status})` : ''}`, 'danger');
        }
      );
  }, [id, showToast]);

  useEffect(() => {
    if (id) retrieveModel();
    else setModel(new BdaModelDTO());
  }, [id, retrieveModel]);

  const renderAsyncContent = useCallback(() => {
    if (error) return (
      <Alert
        type="error"
        showIcon
        message="An error occured while retrieving model. Try again later."
      />
    );

    return model
      ? <AssetEditForm asset={model} mode="model" modeLabel="Model" />
      : (
        <div className="p-5 text-center">
          <AppLoader />
        </div>
      );
  }, [error, model]);

  return (
    <Container className="mt-3">
      <Helmet>
        <title>Model {id ? `${id} Edit` : "Registration"}</title>
      </Helmet>

      <Breadcrumb>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/models' }}>Models</Breadcrumb.Item>
        {id
          ? (
            <>
              <Breadcrumb.Item linkAs={Link} linkProps={{ to: `/models/${id}` }}>{model?.name}</Breadcrumb.Item>
              <Breadcrumb.Item active>Edit</Breadcrumb.Item>
            </>
          )
          : (
            <Breadcrumb.Item active>New Model</Breadcrumb.Item>
          )}
      </Breadcrumb>

      <Card className="mb-3">
        <Row className="gx-0 border-bottom p-2 px-3 align-items-center">
          <Col>
            <h5 className="mb-1">{id ? 'Edit' : 'New'} Model</h5>
            <h6 className="text-muted mb-0">{id ? 'Edit existing model.' : 'Register new model below.'}</h6>
          </Col>
        </Row>

        {renderAsyncContent()}
      </Card>
    </Container>
  );
}